module.exports = __webpack_public_path__ + "img/content-1.aa473077.png";